<template>
  <Menu
    as="div"
    class="relative inline-block text-left"
  >
    <div>
      <MenuButton class="inline-flex w-full justify-right px-4 py-2 text-2xl text-vp-dark font-bold focus:outline-none">
        ...
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div class="px-1 py-1">
          <MenuItem v-slot="{ active }">
            <button
              :class="active ? 'bg-vp-primary text-white' : 'text-gray-900'"
              class="group flex w-full items-center rounded-md px-2 py-2 text-sm"
              @click="saveTemplate"
            >
              Save as template...
            </button>
          </MenuItem>
        </div>
        <div class="px-1 py-1">
          <MenuItem
            v-slot="{ active }"
            disabled
          >
            <div
              :class="active ? 'bg-vp-primary text-white' : 'text-gray-900'"
              class="group flex w-full items-center rounded-md px-2 py-2 text-sm"
            >
              Apply saved template
            </div>
          </MenuItem>
        </div>
        <MenuItem
          v-for="template in templates"
          :key="template.id"
          v-slot="{ active }"
          as="div"
          class="p-1"
        >
          <button
            :class="active ? 'bg-vp-primary text-white' : 'text-gray-900'"
            class="group flex w-full items-center rounded-md px-2 py-2 text-sm"
            @click="applyTemplate(template.id)"
          >
            {{ template.templateName }}
          </button>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { computed } from 'vue';

const offerSheetStore = useOfferSheetStore();
const templates = computed(() => offerSheetStore.templates);

const emit = defineEmits<{
  (e: 'save'): void;
  (e: 'apply', templateId: number): void;
}>();

const saveTemplate = () => {
  emit('save');
};

const applyTemplate = async id => {
  emit('apply', id);
};
</script>
